exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".page-overlay[data-v-5a08aa64]{position:fixed;display:none;width:100%;height:100%;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:2;cursor:pointer}.page-overlay.show[data-v-5a08aa64]{display:block}", "", {"version":3,"sources":["/app/src/components/common/overlay.vue"],"names":[],"mappings":"AACA,+BACI,eAAgB,AAChB,aAAc,AACd,WAAY,AACZ,YAAa,AACb,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,gCAAkC,AAClC,UAAW,AACX,cAAgB,CACnB,AACD,oCACI,aAAe,CAClB","file":"overlay.vue","sourcesContent":["\n.page-overlay[data-v-5a08aa64] {\n    position: fixed;\n    display: none;\n    width: 100%;\n    height: 100%;\n    top: 0; \n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0,0,0,0.5);\n    z-index: 2;\n    cursor: pointer;\n}\n.page-overlay.show[data-v-5a08aa64] {\n    display: block;\n} \n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-5a08aa64","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/overlay.vue
// module id = 2038
// module chunks = 79